import { Mongo } from 'meteor/mongo';
import SimpleSchema from 'simpl-schema';

const APISettings = new Mongo.Collection('APISettings');

APISettings.allow({
  insert: () => false,
  update: () => false,
  remove: () => false
});

APISettings.deny({
  insert: () => true,
  update: () => true,
  remove: () => true
});
const APISettingsSchema = new SimpleSchema({
  deployConfigAPI: {
    type: String,
    label: 'What is the URL?'
  },
  svgCategoryListAPI: {
    type: String,
    label: 'What is the URL?'
  },
  sendUserLocationAPI: {
    type: String,
    label: 'What is the URL?'
  },
  OGRLayerAPI: {
    type: String,
    label: 'What is the URL?'
  },
  value: {
    type: SimpleSchema.oneOf(Boolean, Number, String),
    label: 'The value for the setting',
    optional: true
  }
});

APISettings.attachSchema(APISettingsSchema);

export default APISettings;
